<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'cwgl_cwxx_cwjf'}" style="position: absolute;top: 32px;left: 220px;">
			<el-button size="mini">回到计费单</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 25%;">
					<el-form-item label="客户名称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="客户简称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="计费月份">
						<el-date-picker v-model="lists.yf" align="right" type="month" size="mini" format="yyyy-MM" value-format="yyyy-MM" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="日期">
						<el-date-picker v-model="lists.ddrq" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>
			
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 20px;">
				<div class="m-4 d-flex">
					<div>冷藏费类目-{{lists.yf}}</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="lcflist" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column prop="bh" label="货物条码" width="120" align="center"></el-table-column>
						<el-table-column label="包装叫法" width="140" prop="bzjf"></el-table-column>
						<el-table-column label="开始日" align="center" width="110" prop="ksr"></el-table-column>
						<el-table-column label="结束日" align="center" width="110" prop="jsr"></el-table-column>
						<el-table-column label="天数" align="center" width="110" prop="ts"></el-table-column>
						<el-table-column label="单价" align="center" width="110" prop="dj"></el-table-column>
						<el-table-column label="数量" align="center" width="110">
							<template slot-scope="scope">
								{{scope.row.sl}}<span style="margin-left: 4px;">{{lmfdw}}</span>
							</template>
						</el-table-column>
						<el-table-column label="金额" align="center" width="110" prop="je"></el-table-column>
					</el-table>
				</div>
			</div>
			
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 180px;">
				<div class="m-4 d-flex">
					<div>其他服务费类目-{{lists.yf}}</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="qtfylist" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column prop="rq" label="日期" width="120" align="center"></el-table-column>
						<el-table-column label="项目" width="140" prop="xm"></el-table-column>
						<el-table-column label="计费数量" align="center" width="110">
							<template slot-scope="scope">
								{{scope.row.jfsl}}<span style="margin-left: 4px;">{{scope.row.jfdw}}</span>
							</template>
						</el-table-column>
						<el-table-column label="单价" align="center" width="110" prop="dj"></el-table-column>
						<el-table-column label="金额" align="center" width="110" prop="je"></el-table-column>
						<el-table-column label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.desc" size="mini"></el-input>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="width: 160px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{lists.cjrname}}</span></div>
			<div style="width: 200px;">
				冷藏费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.lcf_ze}}</span>元
			</div>
			<div style="width: 240px;">
				其他服务费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.qtf_ze}}</span>元
			</div>
			<div style="width: 200px;">
				总费用：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.zfy}}</span>元
			</div>
			<el-button type="primary" @click="submit" style="margin-left: 5%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],
		components: {
			buttonSearch
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				ccjs:0,
				ccmj:0,
				cctj:0,
				cczl:0,
				zfy:0,
				lists: {
				},
				ywylist:[],
				khlist:[],
				cklist:[],
				ckcplist:[],
				bmlist:[],
				valuea: false,
				createModel: false,
				preUrl: 'khkc',
				multipleSelection:[],
				lcflist:[],
				qtfylist:[],
				
				lmfdw:'',
				tableDatab:[],
				
				hwlxlist:[],
				hyfslist:[],
				jfdwlist:[],
				jfbzlist:[],
				hwbzlist:[],
				hyzlist:[],
				
				flfylxlist: [],
				search: {
					keyword: "",
					bh:''
				},
				bantj:1.68 ,//每板体积
				dqkhxx:{} // 当前客户信息
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
		

			
		},
		created() {
			this.lists = this.$route.params.data;
			this.lists.cjrname = this.user.name
			this.qtf_ze = this.lists.qtf_ze
			this.lcf_ze = this.lists.lcf_ze
			this.zfy = this.lists.zfy
			this.lcflist = this.lists.lcflist
			this.qtfylist = this.lists.qtfylist
			if(this.lists.hwxm != 0){
				this.ccddhw = this.lists.ccddhw
			}
			
			this.axios.get('/admin/flflx/1', { token: true }).then(res => {
				this.flfylxlist = res.data.data.list;
			});
			this.axios.get('/admin/hyxl/1', { token: true }).then(res => {
				this.hyzlist = res.data.data.list;
			});
			this.axios.get('/admin/thlx/1', { token: true }).then(res => {
				this.hyfslist = res.data.data.list;
			});
			this.axios.get('/admin/khxxs', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});
			
			this.axios.get('/admin/hwlx/1', { token: true }).then(res => {
				this.hwlxlist = res.data.data.list;
			});
			this.axios.get('/admin/jfdw/1', { token: true }).then(res => {
				this.jfdwlist = res.data.data.list;
			
			});
			
			this.axios.get('/admin/jfbz/1', { token: true }).then(res => {
				this.jfbzlist = res.data.data.list;
			});
			
			this.axios.get('/admin/hwbz/1', { token: true }).then(res => {
				this.hwbzlist = res.data.data.list;
			});
			
		},
		methods: {
			curr(val){
				let data = this.khlist.filter(item=>{
					return item.id == val
				})
				this.dqkhxx = data[0]
				let lcf = 0
				let qtf = 0
				this.axios.get('/admin/lcflist/'+this.dqkhxx.id, { token: true }).then(res => {
					this.lcflist = res.data.data;
					this.axios.get('/admin/qtfylist/'+this.dqkhxx.id, { token: true }).then(res => {
						this.qtfylist = res.data.data;
						for(let i of this.lcflist){
							lcf += parseFloat(i.je)
						}
						for(let e of this.qtfylist){
							qtf += parseFloat(e.je)
						}
						this.lists.qtf_ze = qtf
						this.lists.lcf_ze = lcf
						this.lists.zfy = (qtf + lcf).toFixed(2)
					});
				});
				
				let datas = this.jfdwlist.filter(item=>{
					return item.id == data[0].jfdw_id
				})
				this.lmfdw = datas[0].name
				
				
			},

			pustyl() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{
					this.getList()
					this.createModel = true;
				}
			},
			pustyldel(e) {
				this.ccddhw.splice(e,1)
			},
			submits(e) {
				this.lists.hwxm = e.length
				this.ccddhw = e.map(i=>{
					return {
						kc_id:i.id,
						bh:i.bh,
						kh_id:i.kh_id,
						hwmc:i.hwmc,
						bzjf:i.bzjf,
						hwbz:i.hwbzlx.name,
						bsl:i.bsl,
						kcjs:i.js,
						kc:i.kc,
						djmj:i.djmj,
						djtj:i.djtj,
						djzl:i.djzl,
						js:0,
					}
				})
				this.createModel = false;
			},
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&bh=${this.search.bh}&kh_id=${this.lists.kh_id}&ck_id=${this.lists.ck_id}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},


			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.search.keyword = e
					this.getList()
					return
				}
				// 高级搜索
				this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.search = {
					keyword: "",
					bh: '',
				}
			},
			//提交
			submit() {
				this.lists.lcflist = this.lcflist
				this.lists.qtfylist = this.qtfylist
				let x = this.lists
				this.layout.showLoading()
				let url = this.lists.id === 0 ? '/admin/jfdd' : '/admin/jfdd/' + this.lists.id
				
				this.axios.post(url, x, {
					token: true
				}).then(res => {
					console.log(res);
					this.$message({
						type: "success",
						message: this.lists.id === 0 ? "开单成功" : "修改成功"
					})
					this.$router.push({
						name: "cwgl_cwxx_cwjf"
					})
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
	    margin-bottom: 4px !important;
	}
	.pt-a{
		padding-top: 20px;
	}
	.el-form-item__label {
		width: 84px !important;
	}
</style>
